module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "footnotes"
  }, _vm._l(([].concat(_vm.data.list)), function(footnote, key) {
    return _c('p', {
      key: key
    }, [_c('span', {
      staticClass: "footnote-number"
    }, [_vm._v(_vm._s(key + 1) + ")")]), _vm._v("\n    " + _vm._s(footnote) + "\n  ")])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08871bd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockFootnotes.vue
// module id = 653
// module chunks = 0